import React, { useState } from "react";
import { FiMessageSquare } from "react-icons/fi";

const ChatOverlay = ({ heading, name, number, onClose, propertyMobile }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    onClose();
  };

  const handleOpenMessagingApp = () => {
    const phoneNumber = propertyMobile; // Include the country code here
    const message = "Hello, I need some help!";
    const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;

    window.location.href = smsLink;
  };

  if (!isVisible) return null;

  return (
    <div className="bg-gray-800 p-4 rounded-lg shadow-lg text-white w-60 flex-shrink-0">
      <div className="flex justify-between items-center mb-2">
        <p className="text-sm opacity-70">{heading}</p>
        <button className="text-gray-400 text-2xl ml-2" onClick={handleClose}>
          &times;
        </button>
      </div>
      <div>
        <h4 className="text-lg font-semibold">{name}</h4>
        <p className="text-sm">{propertyMobile}</p>
      </div>
      <button
        className="mt-4 w-full bg-indigo-600 text-white py-2 rounded-lg border-2 border-gray-50 hover:bg-indigo-700"
        onClick={handleOpenMessagingApp}
      >
        <div className="flex space-x-1 items-center justify-center">
          <FiMessageSquare />
          <div>Chat Now</div>
        </div>
      </button>
    </div>
  );
};

export default ChatOverlay;
